import api from "./axios";
import type { Enrollment } from "../types";

interface CreateEnrollmentData {
  camperId: number;
  year: number;
  cabinId?: number | null;
  overrideCabinId?: number | null;
  termId?: number | null;
}

export const enrollmentsApi = {
  list: async (params?: { camperId?: number; year?: number }): Promise<Enrollment[]> => {
    const res = await api.get<Enrollment[]>("/enrollments", { params });
    return res.data;
  },

  create: async (data: CreateEnrollmentData): Promise<Enrollment> => {
    const res = await api.post<Enrollment>("/enrollments", data);
    return res.data;
  },

  update: async (id: number, data: Partial<CreateEnrollmentData>): Promise<Enrollment> => {
    const res = await api.put<Enrollment>(`/enrollments/${id}`, data);
    return res.data;
  },

  /**
   * Set or clear the admin cabin override on a single enrollment row.
   * Pass `cabinId: null` to clear. Backend records override_set_by /
   * override_set_at audit fields automatically. Admin/director only.
   */
  overrideCabin: async (
    id: number,
    data: { cabinId: number | null; reason?: string | null },
  ): Promise<Enrollment> => {
    const res = await api.patch<Enrollment>(`/enrollments/${id}/override-cabin`, data);
    return res.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/enrollments/${id}`);
  },
};
